import { useTranslation } from 'react-i18next'
import { DataItem } from 'scrivito'

import { DataItemForm } from '../DataItemForm'
import { Button } from '@/Atomic/Molecules/Button'
import {
  Drawer,
  DrawerBody,
  DrawerFooter,
  DrawerHeader,
} from '@/Atomic/Templates/Drawer'
import { LoadingOverlay } from '@/Components/LoadingOverlay/LoadingOverlay'
import { useDataItemEdit } from '@/utils/CRUD/hooks/useDataItemEdit'

import './DataItemDrawer.scss'

interface DataItemDrawerProps {
  dataItem: DataItem
  isOpen: boolean
  close: () => void
}

export const DataItemEditingDrawer: React.FC<DataItemDrawerProps> = ({
  dataItem,
  isOpen,
  close,
}) => {
  const { t } = useTranslation()

  const { methods, onSubmit, onFormSubmit, isLoading } =
    useDataItemEdit(dataItem)

  const handleSave = () => {
    methods.handleSubmit(async (data) => {
      const isSuccessful = await onSubmit(data)

      if (isSuccessful) {
        close()
      }
    })()
  }

  return (
    <Drawer isOpen={isOpen} close={close} direction="right">
      <LoadingOverlay loading={isLoading}>
        <DrawerHeader>
          <div className="header item">
            <Button
              variant="icon"
              icon="cross"
              tooltip={t('tooltip.close')}
              onClick={close}
            />
          </div>
        </DrawerHeader>
        <DrawerBody>
          <DataItemForm
            dataItem={dataItem}
            methods={methods}
            onFormSubmit={onFormSubmit}
            isEditing={true}
          />
        </DrawerBody>

        <DrawerFooter align="right">
          <Button variant="outlined" onClick={close} size="lg">
            {t('common.cancel')}
          </Button>
          <Button icon="disk" onClick={handleSave} size="lg">
            {t('common.saveChanges')}
          </Button>
        </DrawerFooter>
      </LoadingOverlay>
    </Drawer>
  )
}
